import { c as _c } from "react/compiler-runtime";
import Skeleton from "@/app/(fevicol-inhomz)/_components/global/Skeleton";

// Shared between loading.jsx (the route segment's server-render fallback)
// and DesignIdeaContractorRows (the client-side "still checking whether a
// city's been picked" skeleton, see CityPopupProvider's CITY_SELECTION_STATUS)
// so the one real shape only exists once.
export default function ContractorCardSkeleton(t0) {
  const $ = _c(4);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `w-full ${className}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="relative aspect-[343/160] w-full overflow-hidden rounded-[--radius8]"><Skeleton width={null} height={null} rounded="rounded-none" className="h-full w-full" /><Skeleton width={64} height={64} rounded="rounded-full" className="absolute -bottom-2 left-4 border-[3px] border-[--colorSurfaceSurface]" /></div>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex flex-col gap-2 px-4 pb-3 pt-4"><Skeleton height={16} width="60%" /><Skeleton height={12} width="40%" /></div>;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t2) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  return t5;
}